import { DialogConfirmation } from '@reapitform/common-ui'
import React, { useEffect } from 'react'
import { IDefaultEmergencyContact } from '../../../../../api/types'
import { useDefaultEmergencyContactDelete } from '../../../../..//api/defaults/emergency-contact'

interface IDeleteConfirmationModal {
  isOpen: boolean
  onOpenChange: (isOpen: boolean) => void
  refreshList: (
    data: IDefaultEmergencyContact[] | ((preData: IDefaultEmergencyContact[]) => IDefaultEmergencyContact[]),
  ) => void
  data?: IDefaultEmergencyContact
}

export const DeleteConfirmationModal: React.FC<IDeleteConfirmationModal> = ({
  data,
  isOpen,
  onOpenChange,
  refreshList,
}) => {
  const { isLoading, deleteEmergencyContact, isSuccess } = useDefaultEmergencyContactDelete(String(data?.id))

  const handleClose = () => onOpenChange(false)
  const handleConfirm = () => {
    deleteEmergencyContact(undefined)
  }

  useEffect(() => {
    if (!isSuccess || !data?.id) return

    refreshList((prevEmergencyContactList) =>
      prevEmergencyContactList.filter((emergencyContact) => emergencyContact.id !== data.id),
    )
    handleClose()
  }, [isSuccess])

  if (!data) return

  return (
    <DialogConfirmation
      isOpen={isOpen}
      message={`This action will permanently delete the repairer ${data.businessName} and cannot be undone.`}
      onCancel={handleClose}
      onClose={handleClose}
      confirmButtonText="Delete"
      intent="danger"
      title="Delete Repairer"
      onConfirm={handleConfirm}
      isLoading={isLoading}
    />
  )
}
